import { RpcServer } from '../Rpc/RpcServer'
import { PlacementOptions } from '../../../api'
import { merchantRpcClientFactory } from '../merchantRpcClient'
import config from '../../config'

export function adRpcServerFactory(
  window: Window,
  namespace: string,
  placementOptions: PlacementOptions,
  impressionTrackerParams: object,
  samplingDecision: object
): RpcServer {
  const server = new RpcServer(window, namespace)

  server.addEndpoints({
    getPlacementOptions: (event: MessageEvent) => {
      window.kmerchant = merchantRpcClientFactory(window, event.source as WindowProxy, config.MERCHANT_RPC_NAMESPACE, event.origin)

      return placementOptions
    },

    getTrackingParams: () => impressionTrackerParams,

    getSamplingDecision: () => samplingDecision,

    getHeight: () => window.document.body.clientHeight,

    isEmpty: () => !window.document.getElementsByTagName('div').length,

    forceReload: () => window.location.reload()
  })

  return server
}
